import { CustomComponentType, InsuranceTypeOption } from '../../../enums';
import { FinancialSubaccountSelectOptions } from './financial-subaccount-type-select-options';

export class PersonalInsuranceTypeSelectOptions extends FinancialSubaccountSelectOptions {
	static schema(...extend: any) {
		return super.schema(
			{
				type: CustomComponentType.personalInsuranceTypeSelectOptions,
			},
			...extend
		);
	}

	static get builderInfo() {
		return {
			weight: 10,
			schema: PersonalInsuranceTypeSelectOptions.schema({})
		};
	}

	protected async getApiOptions(): Promise<any> {
		return {
			items: [
				{
					label: InsuranceTypeOption.Term,
					value: InsuranceTypeOption.Term,
				},
				{
					label: InsuranceTypeOption.LifeInsurance,
					value: InsuranceTypeOption.LifeInsurance,
				},
				{
					label: InsuranceTypeOption.Other,
					value: InsuranceTypeOption.Other,
				},
			]
		};
	}
}
